"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMarkerArea = void 0;
var markerjs2_1 = require("markerjs2");
var CurvedArrowMarker_1 = require("./CurvedArrowMarker");
var StampMarker_1 = require("./StampMarker");
var getDefaultStrokeWidth_1 = require("./getDefaultStrokeWidth");
var lodash_1 = require("lodash");
var sharedStyles_1 = require("./sharedStyles");
function initMarkerArea(imageElement, imageInfo, mediaContext) {
    var markerArea = new markerjs2_1.MarkerArea(imageElement);
    var defaultStrokeWidth = (0, getDefaultStrokeWidth_1.getDefaultStrokeWidth)();
    setBaseSettings(markerArea, imageInfo, mediaContext, defaultStrokeWidth);
    setStyleSettings(markerArea);
    persistMarkerStyleChanges(markerArea);
    autoOpenColorPicker(markerArea);
    var cleanupFunctions = [addCopyPasteHandler(markerArea), addRetainMarkerShortcut(markerArea)];
    return {
        markerArea: markerArea,
        cleanupMarkerArea: function () {
            for (var _i = 0, cleanupFunctions_1 = cleanupFunctions; _i < cleanupFunctions_1.length; _i++) {
                var cleanup = cleanupFunctions_1[_i];
                cleanup();
            }
        },
        defaultStrokeWidth: defaultStrokeWidth,
    };
}
exports.initMarkerArea = initMarkerArea;
function setBaseSettings(markerArea, imageInfo, mediaContext, defaultStrokeWidth) {
    var _a;
    var _js = mediaContext._js;
    var _b = (_a = mediaContext.mediaConstraints) !== null && _a !== void 0 ? _a : {}, markerColors = _b.markerColors, defaultMarkerColor = _b.defaultMarkerColor;
    markerArea.renderAtNaturalSize = true;
    if (imageInfo.encoding === 'jpeg') {
        markerArea.renderImageType = 'image/jpeg';
        // 100% image quality on huge images causes problems. Lowering it slightly seems to fix it.
        markerArea.renderImageQuality = 0.9;
    }
    markerArea.availableMarkerTypes = [
        'FrameMarker',
        'EllipseFrameMarker',
        'ArrowMarker',
        'LineMarker',
        'MeasurementMarker',
        CurvedArrowMarker_1.CurvedArrowMarker,
        'TextMarker',
        'CalloutMarker',
        'HighlightMarker',
        StampMarker_1.StampMarker,
    ];
    markerArea.settings.displayMode = 'popup';
    if (markerColors && markerColors.length > 0) {
        markerArea.settings.defaultColorSet = markerColors;
        var defaultColor = defaultMarkerColor !== null && defaultMarkerColor !== void 0 ? defaultMarkerColor : markerColors[0];
        markerArea.settings.defaultColor = defaultColor;
        markerArea.settings.defaultFillColor = defaultColor;
    }
    markerArea.settings.defaultColorsFollowCurrentColors = true;
    markerArea.settings.defaultStrokeWidth = defaultStrokeWidth;
    markerArea.settings.defaultStrokeWidths = [
        (0, lodash_1.round)(defaultStrokeWidth * 0.5, 1),
        defaultStrokeWidth,
        (0, lodash_1.round)(defaultStrokeWidth * 1.5, 1),
    ];
    // grabbing the default font family from the body element to make sure it matches the rest of the page
    var defaultFontFamily = getComputedStyle(document.body).fontFamily;
    // this sets the available fonts for the text marker
    markerArea.settings.defaultFontFamilies = [defaultFontFamily];
    markerArea.settings.defaultFontFamily = defaultFontFamily;
    // Only allow solid line styles
    markerArea.settings.defaultStrokeDasharrays = [''];
    markerArea.settings.defaultStrokeDasharray = '';
    markerArea.settings.defaultText = _js('Text');
}
function setStyleSettings(markerArea) {
    markerArea.uiStyleSettings.canvasBackgroundColor = '#a1a1a1';
    // The media manager modal has a large z-index, so we need an even bigger one when opening
    // this editor from an image in the media manager :/
    markerArea.styles.settings.zIndex = sharedStyles_1.editorZIndex;
    markerArea.styles.settings.redoButtonVisible = true;
}
function persistMarkerStyleChanges(markerArea) {
    function handleMarkerEventForStyling(event) {
        // setting defaultColorsFollowCurrentColors will update default colors when
        // are changed, but we want to also follow strokeWidth and strokeDashArray
        var _a;
        var markerState = (_a = event === null || event === void 0 ? void 0 : event.marker) === null || _a === void 0 ? void 0 : _a.getState();
        // set line default line width
        if (markerState === null || markerState === void 0 ? void 0 : markerState.strokeWidth) {
            markerArea.settings.defaultStrokeWidth = markerState.strokeWidth;
        }
        // set the stroke dash array setting
        // default value is empty string, so we need to compare for nullish
        // this value is currently hardcoded, but setting here to future proof
        var dasharray = markerState === null || markerState === void 0 ? void 0 : markerState.strokeDasharray;
        if (dasharray !== undefined && dasharray !== null) {
            markerArea.settings.defaultStrokeDasharray = dasharray;
        }
    }
    // we are handling two events: markerchange and markercreate
    // the latter one because a marker type can be selected and then styling
    // updated before the marker itself is created - so we need to capture this
    markerArea.addEventListener('markerchange', handleMarkerEventForStyling);
    markerArea.addEventListener('markercreate', handleMarkerEventForStyling);
}
function autoOpenColorPicker(markerArea) {
    markerArea.addEventListener('markerselect', function (event) {
        var colorPickerActionNames = ['color-picker-panel', 'stroke-color-panel'];
        for (var _i = 0, colorPickerActionNames_1 = colorPickerActionNames; _i < colorPickerActionNames_1.length; _i++) {
            var actionName = colorPickerActionNames_1[_i];
            var colorPickerButton = event.markerArea.targetRoot.querySelector("[class*=_toolbox_button][data-action=".concat(actionName, "]"));
            if (colorPickerButton) {
                colorPickerButton.click();
                break;
            }
        }
    });
}
function addCopyPasteHandler(markerArea) {
    // handle copy and paste
    var selectedMarkerState;
    function handleCopyPaste(event) {
        var _a;
        // Check for Ctrl or Command key
        if (event.ctrlKey || event.metaKey) {
            if (event.key === 'c' || event.key === 'C') {
                // save state for current marker
                var state = (_a = markerArea === null || markerArea === void 0 ? void 0 : markerArea.currentMarker) === null || _a === void 0 ? void 0 : _a.getState();
                // clone state into its own object - or set to null to clear out value
                selectedMarkerState = state ? (0, lodash_1.cloneDeep)(state) : null;
            }
            else if (selectedMarkerState && (event.key === 'v' || event.key === 'V')) {
                shiftPosition(selectedMarkerState);
                var markerAreaState = markerArea.getState();
                markerAreaState.markers.push(selectedMarkerState);
                markerArea.restoreState(markerAreaState);
            }
        }
    }
    document.addEventListener('keydown', handleCopyPaste);
    return function () {
        document.removeEventListener('keydown', handleCopyPaste);
    };
}
function shiftPosition(state) {
    // take markerState and shift it slightly down and rightward
    var OFFSET = 20;
    if (state.x1 && state.x2 && state.y1 && state.y2) {
        // shift box coordinates
        state.x1 += OFFSET;
        state.x2 += OFFSET;
        state.y1 += OFFSET;
        state.y2 += OFFSET;
        // shift curved arrow 3rd point
        if (state.curveX && state.curveY) {
            state.curveX += OFFSET;
            state.curveY += OFFSET;
        }
    }
    else if (state.top && state.left) {
        // shift linear coordinates
        state.top += OFFSET;
        state.left += OFFSET;
    }
}
function addRetainMarkerShortcut(markerArea) {
    var SHORTCUT_KEY = 'Alt';
    var retainLastMarker = false;
    var lastRetainedMarker = null;
    markerArea.addEventListener('markercreate', function (event) {
        var _a;
        if (!retainLastMarker) {
            return;
        }
        lastRetainedMarker = (_a = event.marker) !== null && _a !== void 0 ? _a : null;
        if (lastRetainedMarker) {
            // Re-enter into "create mode" with the same type as the last created marker.
            // Calling createNewMarker is equivalent to the user selecting the marker type from the top
            // bar of the editor. The marker will not render until the user clicks/taps on the image
            // (despite the confusing name).
            event.markerArea.createNewMarker(lastRetainedMarker.typeName);
        }
    });
    function startRetainingLastMarker(event) {
        if (event.key !== SHORTCUT_KEY) {
            return;
        }
        // Enable `retainLastMarker` so we know to re-enter "create mode" after the next marker
        // is created.
        retainLastMarker = true;
    }
    function stopRetainingLastMarker(event) {
        var _a;
        if (event.key !== SHORTCUT_KEY) {
            return;
        }
        retainLastMarker = false;
        if (((_a = markerArea.currentMarker) === null || _a === void 0 ? void 0 : _a.state) === 'new') {
            // We only need to switch back to "select mode" if the user is in "create mode" but not
            // actively drawing anything yet. Otherwise, the editor will handle everything like normal.
            markerArea.switchToSelectMode();
            if (lastRetainedMarker) {
                // Select the last drawn marker to mimic the built-in behavior of drawing a single marker.
                markerArea.setCurrentMarker(lastRetainedMarker);
            }
        }
        lastRetainedMarker = null;
    }
    document.addEventListener('keydown', startRetainingLastMarker);
    document.addEventListener('keyup', stopRetainingLastMarker);
    return function () {
        document.removeEventListener('keydown', startRetainingLastMarker);
        document.removeEventListener('keyup', stopRetainingLastMarker);
    };
}
